import React from "react";

import app from "app.module.css";
import homepage from "./homepage.module.css";
import useWindowDimensions from "utils/windowdimensions";
import useDarkMode from "use-dark-mode";

const Homepage: React.FC = () => {
  const darkMode = useDarkMode();
  const { width } = useWindowDimensions();

  const renderHeading = () => (
    <div className={homepage.heading_section}>
      <span
        className={homepage.heading}
        style={{ color: darkMode.value ? "#e7f0fa" : "#2c2e3f" }}
      >
        Wang Luo
      </span>
    </div>
  );

  return (
    <div id='homepage' className={app.page_block}>
      {width > 576 && <div className={app.blank_space} />}
      <div>
        <p
          className={homepage.intro_message_top}
          style={{ color: darkMode.value ? "#e7f0fa" : "#2c2e3f" }}
        >
          Hello there, I'm
        </p>
      </div>
      {renderHeading()}
      <div className={homepage.introduction}>
        <p
          className={homepage.intro_message}
          style={{ color: darkMode.value ? "#e7f0fa" : "#2c2e3f" }}
        >
          I enjoy turning creative ideas and beautiful designs into reality ;)
        </p>
        <p
          className={homepage.intro_message}
          style={{ color: darkMode.value ? "#e7f0fa" : "#2c2e3f" }}
        >
          Currently an iOS engineer at TikTok.
        </p>
      </div>
      <div className={homepage.contact}>
        <div
          className={
            darkMode.value ? homepage.action_dark : homepage.action
          }
        >
          <a href={"https://github.com/Asthenosphere"} target='_blank' rel='noreferrer'>
            <span
              style={{ color: darkMode.value ? "#e7f0fa" : "#2c2e3f" }}
            >
              GitHub
            </span>
          </a>
        </div>
        <div
          className={
            darkMode.value ? homepage.action_dark : homepage.action
          }
        >
          <a href={"https://www.linkedin.com/in/wang-luo-98016a191/"} target='_blank' rel='noreferrer'>
            <span
              style={{ color: darkMode.value ? "#e7f0fa" : "#2c2e3f" }}
            >
              LinkedIn
            </span>
          </a>
        </div>
        <div
          className={
            darkMode.value ? homepage.action_dark : homepage.action
          }
        >
          <a href={"mailto:gwyw9899@gmail.com"} target='_blank' rel='noreferrer'>
            <span
              style={{ color: darkMode.value ? "#e7f0fa" : "#2c2e3f" }}
            >
              Email
            </span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Homepage;
